import { render, staticRenderFns } from "./OrderCompletion.vue?vue&type=template&id=e52e9320&scoped=true&"
import script from "./OrderCompletion.vue?vue&type=script&lang=js&"
export * from "./OrderCompletion.vue?vue&type=script&lang=js&"
import style0 from "./OrderCompletion.vue?vue&type=style&index=0&id=e52e9320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52e9320",
  null
  
)

export default component.exports